import axios from 'axios'
import { httpEventBus } from './httpEventBus'

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
})

axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 403 && !error.config?.suppressForbiddenHandler) {
            const method = (error.config?.method || 'get').toLowerCase()
            const serverMessage = error.response.data?.message
            const fallback = "You don't have permission to perform this action."
            const message = serverMessage || fallback

            if (method === 'get') {
                httpEventBus.navigate('/admin/forbidden', {
                    replace: true,
                    state: {
                        message,
                        from: error.config?.url,
                    },
                })
            } else {
                httpEventBus.notify(message, 'error')
            }

            if (error.response) {
                error.response.data = { ...(error.response.data || {}), __handled: true }
            }
        }
        return Promise.reject(error)
    }
)

export default axiosInstance
